export default IconTransferVertical => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-transfer-vertical" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M10 4v16l-6 -5.5" />
  <path d="M14 20v-16l6 5.5" />
</svg>`;